var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4422 16.8002C55.4422 16.8002 54.8953 12.9393 53.2109 11.2439C51.0781 9.0127 48.6938 9.00176 47.6 8.87051C39.7688 8.30176 28.0109 8.30176 28.0109 8.30176H27.9891C27.9891 8.30176 16.2312 8.30176 8.4 8.87051C7.30625 9.00176 4.92187 9.0127 2.78906 11.2439C1.10469 12.9393 0.56875 16.8002 0.56875 16.8002C0.56875 16.8002 0 21.3393 0 25.8674V30.1111C0 34.6393 0.557812 39.1783 0.557812 39.1783C0.557812 39.1783 1.10469 43.0393 2.77812 44.7346C4.91094 46.9658 7.71094 46.8893 8.95781 47.1299C13.4422 47.5564 28 47.6877 28 47.6877C28 47.6877 39.7688 47.6658 47.6 47.108C48.6938 46.9768 51.0781 46.9658 53.2109 44.7346C54.8953 43.0393 55.4422 39.1783 55.4422 39.1783C55.4422 39.1783 56 34.6502 56 30.1111V25.8674C56 21.3393 55.4422 16.8002 55.4422 16.8002ZM22.2141 35.2627V19.5236L37.3406 27.4205L22.2141 35.2627Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.0152591fd16428cad74e1fb43d8f7ab8.svg";
export { ForwardRef as ReactComponent };